export default "__VITE_ASSET__6e752d83__"